import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { MadFragment, MAD_FRAGMENT } from "../../fragments";
import { Collection, MadsQueryVariables } from "../../types";

export const GET_MADS = gql`
  query getMad($page: Int, $per: Int, $direction: String, $campaignId: ID) {
    mads(
      page: $page
      per: $per
      direction: $direction
      campaignId: $campaignId
    ) {
      collection {
        ...MadFragment
      }
      metadata {
        totalCount
      }
    }
  }
  ${MAD_FRAGMENT}
`;

export type MadData = { mads: Collection<MadFragment> };

export default (options?: QueryHookOptions<MadData, MadsQueryVariables>) => {
  return useQuery<MadData, MadsQueryVariables>(GET_MADS, options);
};
